import Vue from "vue";
import VueRouter from "vue-router";

import Auth from "../views/auth/Index"
import PageNotFound from "../views/errors/PageNotFound.vue";
import Login from "../views/auth/Login.vue";
import LoginPTSI from "../views/auth/LoginPTSI.vue";
import LoginNaccu from "../views/auth/LoginNaccu.vue";
import ChangePassword from "../views/auth/ChangePassword.vue";

// import Register from "../views/auth/Register.vue";
import ForgotPassword from "../views/auth/ForgotPassword.vue";
import ForgotPasswordPTSI from "../views/auth/ForgotPasswordPTSI.vue";
import ForgotPasswordNaccu from "../views/auth/ForgotPasswordNaccu.vue";
import store from '../store/index';

import AdminRoutes from "./admin";
import axios from "axios";

Vue.use(VueRouter);

const baseRoutes = [

  {
    path: '',
    component: Auth,
    children: [
       // Login
      {
        path: "/login",
        name: "login",
        component: Login,
        meta: {requiresAuth: false},
      },
      {
        path: "/login/id",
        name: "loginPTSI",
        component: LoginPTSI,
        meta: {requiresAuth: false},
      },
      {
        path: "/login/ke",
        name: "loginNaccu",
        component: LoginNaccu,
        meta: {requiresAuth: false},
      },
      {
        path: "/forgot-password",
        name: "ForgotPassword",
        component: ForgotPassword,
        meta: {requiresAuth: false},
      },
      {
        path: "/forgot-password/id",
        name: "ForgotPasswordPTSI",
        component: ForgotPasswordPTSI,
        meta: {requiresAuth: false},
      },
      {
        path: "/forgot-password/ke",
        name: "ForgotPasswordNaccu",
        component: ForgotPasswordNaccu,
        meta: {requiresAuth: false},
      },
      {
        path: "/change-password",
        name: "ChangePassword",
        component: ChangePassword,
        meta: {requiresAuth: false},
      },

      // EUDR Invitation signup
      {
        path: "eudr-invitation-signup/:inviterId?/:inviteeId?",
        name: "EUDRInvitationPage",
        component: () => import("../views/deforestation/dds/auth/eudr-signup.vue"),
        meta: {requiresAuth: false},
      },

      // Diligence Welcome Screen
      {
        path: "/diligence-welcome",
        name: "diligenceWelcome",
        component: () =>
          import("../views/deforestation/dds/auth/WelcomeScreen.vue"),
        meta: {requiresAuth: true},
      }
    
    ]
  },
  {
    path: "/public-dds/:reportEncId",
    name: "diligencePublicReport",
    component: () => import("../views/deforestation/dds/PublicDDSReport.vue"),
    meta: {requiresAuth: false}
  },
  { 
    path: "*", 
    name: "404",
    component: PageNotFound
  },
];

const routes = baseRoutes.concat(AdminRoutes);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach( async (to, from, next) => {
  await store.dispatch('autoLogin');
  await store.dispatch('eudrSettings/loadEudrSetting')
  // if undefined considered requiresAuth as true
  const isAuth = await store.getters.isAuthenticated;
  const currentRouteName = to.name
  // Keep this in sync with Sidebar.vue getSublink() normalizations
  const normalizeRouteName = (name) => {
    if (!name) return name;
    if (name === "adminPermissions") return "AdminPermissions";
    return name;
  };
  const currentRouteNameNormalized = normalizeRouteName(currentRouteName);
  const user = localStorage.getItem('user')
  let sideBarMenu
  if (user) {
    sideBarMenu = JSON.parse(localStorage.getItem('user')).sideBarMenu
  } else {
    sideBarMenu = store && store.getters && store.getters.getUser && store.getters.getUser.sideBarMenu
  }
  if (sideBarMenu) {
    // check for sidebar items with no subMenu
    let currentModule = sideBarMenu.filter(
      item => normalizeRouteName(item.route_path_name) === currentRouteNameNormalized
    )

    // check for sidebar items with subMenu
    if (!currentModule.length) {
      sideBarMenu.forEach(item => {
        if (item.subMenu && item.subMenu.length > 0) {
          item.subMenu.forEach(subItem => {
            if (normalizeRouteName(subItem.route_path_name) === currentRouteNameNormalized) {
              currentModule = [subItem]
            }
          })
        }
      })
    }

    if (currentModule && currentModule.length > 0) {
      const getPermittedActionsData = await axios.get(`/getPermittedActionsData/${currentModule[0].id.replace('/', '__')}`)
      if (getPermittedActionsData.data.success) { 
        await store.dispatch('setModulePermittedActions', getPermittedActionsData.data.data);
      }
    } else {
      await store.dispatch('setModulePermittedActions', []);
    }
  }

  // Helper function to check if user is super admin
  const isSuperAdmin = () => {
    const userData = store.getters.getUser;
    return userData?.user_role_assoc?.some(role => role.id === 'super_admin');
  };

  if(to.meta.requiresAuth === false){
    if(isAuth && (to.name == 'login' || to.name == 'register')){
      // For super admin, redirect to TutorialManagement
      if (isSuperAdmin()) {
        next({name: 'TutorialManagement'});
        return;
      }
      // Check for user's default dashboard
      const defaultDashboard = store?.state?.auth?.user?.default_dashboard
      if(defaultDashboard) {
        next({name: defaultDashboard});
        return;
      }
      next({name: 'AdminDashboard'});
      return;
    }
    next();
  }else{
    if(isAuth){
      const userData = store.getters.getUser;
      
      // List of all default dashboard routes
      const defaultDashboardRoutes = ['AdminDashboard', 'Home', 'Dashboard', 'dashboard', 'DashboardReports', 'IndonesianDashboard'];
      const isDefaultRoute = to.fullPath === '/' || 
                            defaultDashboardRoutes.includes(to.name) || 
                            to.path?.startsWith('/dashboard-reports');
      
      // For super admin, always redirect to TutorialManagement on default routes
      if (isSuperAdmin() && isDefaultRoute) {
        next({ name: 'TutorialManagement' });
        return;
      }
      
      // Check if user is directorate and redirect to activity statistics
      const isDirectorateUser = userData?.user_role_assoc?.some((role) =>
        ['indonesia_directorate', 'kenya_directorate'].includes(role?.id)
      );
      
      if (isDirectorateUser && isDefaultRoute) {
        next({ name: 'activity_statistics' });
        return;
      }
      
      // Special case for TutorialManagement route - allow super admin users
      if(to.name === 'TutorialManagement'){
        if(isSuperAdmin()){
          next()
          return
        } else {
          // Check for user's default dashboard
          const defaultDashboard = store?.state?.auth?.user?.default_dashboard
          if(defaultDashboard) {
            next({name: defaultDashboard})
            return
          }
          // FIX: Redirect to AdminDashboard (Safe) instead of Home (Loop Trigger)
          next({name: 'AdminDashboard'})
          return
        }
      }

      if(to.name == "Faq"){
        next()
        return
      }
      
      if(to['meta'] !== undefined && to.meta["module"] !== undefined){
        console.log('mdll',to)
        const isAuthrised = await store.getters.isRouteAuthrised(to.meta.module)
        console.log('route auth or not',isAuthrised)
        if(!isAuthrised) {
          // For super admin, redirect to TutorialManagement
          if (isSuperAdmin()) {
            next({name: 'TutorialManagement'});
            return;
          }
        // 2. Try Default Dashboard (With Loop Protection)
          // If the user has a preferred dashboard, try that first.
          const defaultDashboard = store?.state?.auth?.user?.default_dashboard;

          // CRITICAL: If the current route (that failed permission) IS the default dashboard,
          // we must skip this block to prevent the infinite loop.
          const isLooping = defaultDashboard && (to.name === defaultDashboard);

          if (defaultDashboard && !isLooping) {
            next({ name: defaultDashboard });
            return;
          }

          // 3. Dynamic Sidebar Fallback (Sorted by Order)
          // Find the first valid route based on the lowest 'order' property
          if (sideBarMenu && sideBarMenu.length > 0) {
            // Sort main menu items by order (ascending)
            // We use [...sideBarMenu] to create a copy so we don't mutate the state
            const sortedMenu = [...sideBarMenu].sort((a, b) => (a.order || 999) - (b.order || 999));

            const firstMenu = sortedMenu[0];
            let targetRouteName = null;

            if (firstMenu.subMenu && firstMenu.subMenu.length > 0) {
              // If submenu exists, sort it by order as well
              const sortedSubMenu = [...firstMenu.subMenu].sort((a, b) => (a.order || 999) - (b.order || 999));
              
              // Pick the first sub-item (e.g., "Plantations" with order 1)
              targetRouteName = sortedSubMenu[0].route_path_name;
            } else {
              // Otherwise pick the main menu item
              targetRouteName = firstMenu.route_path_name;
            }

            // Normalize the name using your helper function
            targetRouteName = normalizeRouteName(targetRouteName);

            // Redirect if valid and different from current route (prevent self-loop)
            if (targetRouteName && targetRouteName !== to.name) {
              next({ name: targetRouteName });
              return;
            }
          }
          
          // FIX: Redirect to AdminDashboard (Safe) instead of Home (Loop Trigger)
          next({ name: 'profile' }); 
          return
        }
      }

      // Check permission for the target redirect (prevents infinite loop)
      // We check both likely module names: 'dashboard_reports' (from admin.js) or 'report_dashboard' (from your API logs)
      const canAccessReports = (await store.getters.isRouteAuthrised('dashboard_reports')) || 
                               (await store.getters.isRouteAuthrised('report_dashboard'));

      // Redirect all clients to approval flow dashboard
      if (to.name === 'Dashboard' || to.name === 'IndonesianDashboard') {
        // For super admin, redirect to TutorialManagement
        if (isSuperAdmin()) {
          next({ name: 'TutorialManagement' });
          return;
        }
        
        // FIX: Only redirect to 'dashboard' (lowercase) if they have permission
        if (canAccessReports) {
           next({ name: 'dashboard' });
           return;
        }
        
        // If no permission for reports, let them stay on the main Dashboard or go to AdminDashboard
        // Assuming 'Dashboard' is the parent that renders <router-view>, we might want to just next()
        // But if Dashboard is just a redirector, send them to AdminDashboard
        next(); 
        return;
      }

      // Handle /home route redirection to approval flow dashboard
      if (to.name === 'Home') {
        // For super admin, redirect to TutorialManagement
        if (isSuperAdmin()) {
          next({ name: 'TutorialManagement' });
          return;
        }
        // Check for user's default dashboard
        const defaultDashboard = store?.state?.auth?.user?.default_dashboard
        if(defaultDashboard) {
          next({ name: defaultDashboard });
          return;
        }
        
        // FIX: Only redirect to 'dashboard' (lowercase) if they have permission
        if (canAccessReports) {
           next({ name: 'dashboard' });
           return;
        }
        
        // Fallback: If they can't see reports, send them to the safe AdminDashboard container
        next({ name: 'AdminDashboard' });
        return;
      }

      if(to.fullPath == '/') {
        // For super admin, redirect to TutorialManagement
        if (isSuperAdmin()) {
          next({name: 'TutorialManagement'});
          return;
        }
        // Check for user's default dashboard
        const defaultDashboard = store?.state?.auth?.user?.default_dashboard
        if(defaultDashboard) {
          next({name: defaultDashboard})
        } else {
          // This is already correct (AdminDashboard is safe)
          next({name: 'AdminDashboard'})
        }
      } else{
        next();
      }
    }else{
      // console.log('sss')
      next({name: 'login'})
    }
  }
});

export default router;